import Vue from "vue";
import App from "./App.vue";
import ElementUI from "element-ui";
import '@/assets/styles/element-variables.scss';
// import router from "./router"; // 导入路由配

Vue.prototype.$config = window.config;
Vue.config.productionTip = false;
Vue.use(ElementUI);
new Vue({
    // router, // 注入路由
    render: (h) => h(App),
}).$mount("#app");

console.log(window.config);

console.log('打包时间:', process.env.PACK_TIME);
